import {Banner, Link} from '@primer/react'
import {useEffect, type MouseEvent} from 'react'
import {announce} from '@github-ui/aria-live'

import {useBatchComposition} from '../../../stores/layout-selectors'

const DISALLOWED_TAB_TITLE = 'Commit suggestions unavailable'
const DISALLOWED_TAB_MESSAGE = "This batch cannot be committed directly to this pull request's branch."

export type ManageBatchDisallowedTabBannerProps = {
  onSwitchToFixWithCopilot?: () => void
}

export function ManageBatchDisallowedTabBanner({onSwitchToFixWithCopilot}: ManageBatchDisallowedTabBannerProps) {
  const batchComposition = useBatchComposition()
  const shouldShowWarning = batchComposition === 'mixed' || batchComposition === 'no-suggestion'

  useEffect(() => {
    if (shouldShowWarning) {
      announce(DISALLOWED_TAB_MESSAGE)
    }
  }, [shouldShowWarning])

  if (!shouldShowWarning) {
    return null
  }

  const handleSwitchToFix = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    onSwitchToFixWithCopilot?.()
  }

  return (
    <Banner
      className="mb-3"
      variant="warning"
      title={DISALLOWED_TAB_TITLE}
      hideTitle
      description={
        <>
          {DISALLOWED_TAB_MESSAGE}
          {onSwitchToFixWithCopilot && (
            <>
              {' '}
              <Link className="Link--inTextBlock" href="#manage-batch-tab-fix" inline onClick={handleSwitchToFix}>
                Fix with Copilot instead
              </Link>
            </>
          )}
        </>
      }
    />
  )
}
